// eslint-disable-next-line no-unused-vars
import React from 'react'; 
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

const styles = () => ({
	root: {
		width: "100%",
	},
	submit_btn: {
	    color: "#4a4a49",
	    cursor: "pointer",
	    margin: ".25em 0",
	    display: "block",
	    position: "relative",
	    overflow: "hidden",
	    fontSize: "1.5em",
	    textAlign: "center",
	    userSelect: "none",
	    paddingTop: ".7em",
	    whiteSpace: "nowrap",
	    textShadow: "none",
	    lineHeight: "0.75em",
	    fontWeight: "bolder",
	    fontFamily: "AIGFutura_Bold",
	    borderWidth: 1,
	    borderStyle: "solid",
	    paddingLeft: 0,
	    borderColor: "#fdb913",
	    paddingRight: 0,
	    textOverflow: "ellipsis",
	    borderRadius: 2,
	    paddingBottom: ".7em",
	    textTransform: "capitalize",
	    backgroundClip: "padding-box",
	    textDecoration: "none !important",
	    backgroundColor: "#fdb913",
	    "&:hover": {
	        color: "#4a4a49",
		    textShadow: "none",
		    borderColor: "#ffd96c",
		    backgroundColor: "#ffd96c",
	    },
	    "&:focus": {
	        boxShadow: "0 0 12px #3388cc",
	    },
	},
});

interface PassInProperty{
	classes: any,
	t: any,
	label: string,
	title: string,
	onClickEvent: any
}	

@withStyles(styles)
@withTranslation()
class SubmitButton extends React.Component<> {
	
	render(){
	
		const { classes, t, label, title, onClickEvent } = this.props;

		return (
			<div className={classes.root}>
			  <a className={classes.submit_btn}
				onClick={onClickEvent}
				href="#">
					{title ? (
						title
					) : (
						t(label)
					)}
			  </a>
			</div>
		);
	
	}
}

export default SubmitButton;